import request from './request'

export function GetUserInfo() {
    return request({
        url:'/api/currentUser',
        method:'get'
    })
}
export function Login(data) {
    return request({
        url:'/api/login',
        method:'post',
        data:data
    })
}
export function LoginByPassword(data) {
    return request({
        url:'/api/loginByPassword',
        method:'post',
        data:data
    })
}
//更新本人信息（完善资料
export function UpdateSelf(data) {
    return request({
        url:'/api/member/updateSelf',
        method:'put',
        data:data
    })
}
export function GetCaseList(data) {
    return request({
        url:'/api/case/list',
        method:'get',
        params:data
    })
}
export function GetCaseCardList(data) {
    return request({
        url:'/api/caseCard/all',
        method:'get',
        params:data
    })
}
export function GetCaseCardInfo(data) {
    return request({
        url:'/api/caseCard/info',
        method:'get',
        params:data
    })
}
export function GetConsultRecord(data) {
    return request({
        url:'/api/case/getConsultRecord',
        method:'get',
        params:data
    })
}
export function GetCaseInfo(data) {
    return request({
        url:'/api/case/info',
        method:'get',
        params:data
    })
}
export function GetListByTypeCode(data) {
    return request({
        url:'/api/category/getListByTypeCode',
        method:'get',
        params:data
    })
}
export function UpdateCaseCard(data) {
    return request({
        url:'/api/caseCard/update',
        method:'put',
        data:data
    })
}
export function SavePizhu(data) {
    return request({
        url:'/api/caseCard/savePizhu',
        method:'post',
        data:data
    })
}
export function SavePizhu2(data) {
    return request({
        url:'/api/caseCard/savePizhu2',
        method:'post',
        data:data
    })
}
export function SaveBigCasePizhu2(data) {
    return request({
        url:'/api/case/saveBigCasePizhu2',
        method:'post',
        data:data
    })
}
export function GetDoctorList(url,data) {
    return request({
        url:url,
        method:'get',
        params:data
    })
}
export function GetAllowShowCity() {
    return request({
        url:'/api/member/allowShowCity',
        method:'get'
    })
}
export function GetBbxList(data) {
    return request({
        url:'/api/bbx/list',
        method:'get',
        params:data
    })
}
export function SaveBbx(data) {
    return request({
        url:'/api/bbx/save',
        method:'post',
        data:data
    })
}
export function SaveSuggest(data) {
    return request({
        url:'/api/caseCard/suggest',
        method:'post',
        data:data
    })
}
export function Logout() {
    return request({
        url:'/api/logout',
        method:'post',
        data:{}
    })
}
export function CreateCase(data) {
    return request({
        url:'/api/case/create',
        method:'post',
        data:data
    })
}
export function CreateCaseCard(data) {
    return request({
        url:'/api/caseCard/create',
        method:'post',
        data:data
    })
}
export function GetCardList(data) {
    return request({
        url:'/api/caseCard/list',
        method:'get',
        params:data
    })
}
export function GetArea(data) {
    return request({
        url:'/api/area',
        method:'get',
        params:data
    })
}
export function DeleteCaseCard(data) {
    return request({
        url:'/api/caseCard/delete',
        method:'post',
        data:data
    })
}
//获取卡CurUserIsInGroup
export function GetOtherInfo(data) {
    return request({
        url:'/api/caseCard/getOtherInfo',
        method:'get',
        params:data
    })
}
//补充卡其它资料
export function UpdateOtherInfo(data) {
    return request({
        url:'/api/caseCard/updateOtherInfo',
        method:'post',
        data:data
    })
}
//创建群
export function CreateTeam(data) {
    return request({
        url:'/api/case/createTeam',
        method:'post',
        data:data
    })
}
//订单中心
export function GetOrder(data) {
    return request({
        url:'/api/order/info',
        method:'get',
        params:data
    })
}
//取消订单
export function CancelOrder(data) {
    return request({
        url:'/api/order/cancel',
        method:'post',
        data:data
    })
}
//获取乐普隐形矫治首阶段网页URL
export function GetLpyxjzWebUrl(data) {
    return request({
        url:'/api/case/getLpyxjzWebUrl',
        method:'get',
        params:data
    })
}
//转为全周期辅导咨询
export function ToFullConsult(data) {
    return request({
        url:'/api/case/toFullConsult',
        method:'get',
        params:data
    })
}
//延长24小时
export function DelayChat(data) {
    return request({
        url:'/api/case/delay',
        method:'get',
        params:data
    })
}
//聊天框中医生领取耗材
export function DoctorClaim(data) {
    return request({
        url:'/api/order/doctorClaim',
        method:'post',
        data:data
    })
}
//聊天框中医生拒绝耗材
export function DoctorReject(data) {
    return request({
        url:'/api/order/doctorReject',
        method:'post',
        data:data
    })
}
//聊天框中医生拒绝耗材
export function CreateSjd(data) {
    return request({
        url:'/api/caseCard/createSjd',
        method:'post',
        data:data
    })
}
//套餐耗材领取情况
export function ReceiveHcData(data) {
    return request({
        url:'/api/case/receiveData',
        method:'get',
        params:data
    })
}
//获取系统消息
export function GetSysMessage(data) {
    return request({
        url:'/api/sysMessage/list',
        method:'get',
        params:data
    })
}
//获取系统消息
export function GetMeetingMemberList(data) {
    return request({
        url:'/api/meeting/getMemberList',
        method:'get',
        params:data
    })
}
//检查会议是否多次创建
export function CheckMultipleCreate(data) {
    return request({
        url:'/api/meeting/checkMultipleCreate',
        method:'get',
        params:data
    })
}
//获取参与的会议列表
export function GetJoinedMeeting(data) {
    return request({
        url:'/api/meeting/getJoinedMeeting',
        method:'get',
        params:data
    })
}
//会议详情
export function GetMeetingInfo(data) {
    return request({
        url:'/api/meeting/info',
        method:'get',
        params:data
    })
}
//创建会议
export function CreateMeeting(data) {
    return request({
        url:'/api/meeting/create',
        method:'post',
        data:data
    })
}
//创建会议
export function UpdateMeeting(data) {
    return request({
        url:'/api/meeting/update',
        method:'put',
        data:data
    })
}
//创建会议
export function GenerateBigCase(data) {
    return request({
        url:'/api/case/generateBigCase',
        method:'post',
        data:data
    })
}
//获取本人创建的通知
export function GetNoticeList(data) {
    return request({
        url:'/api/notice/list',
        method:'get',
        params:data
    })
}
//获取本人创建的通知
export function CreateNotice(data) {
    return request({
        url:'/api/notice/create',
        method:'post',
        data:data
    })
}
//发送通知
export function SendNotice(data) {
    return request({
        url:'/api/notice/send',
        method:'post',
        data:data
    })
}
//发送通知
export function DeleteNotice(data) {
    return request({
        url:'/api/notice/delete',
        method:'post',
        data:data
    })
}
//用户列表
export function GetMemberList(data) {
    return request({
        url:'/api/member/list',
        method:'get',
        params:data
    })
}
//立即协助
export function Assist(data) {
    return request({
        url:'/api/case/assist',
        method:'get',
        params:data
    })
}

//判断当前人员是否在病例中
export function CurUserIsInGroup(data) {
    return request({
        url:'/api/case/curUserIsInGroup',
        method:'get',
        params:data
    })
}
